<div
  class="border-default bg-surface flex items-center gap-4 rounded-sm border p-3"
  [class.border-red-500]="hasError()">
  @if (!isEmpty()) {
    <svg
      [attr.width]="thumbWidth"
      [attr.height]="thumbHeight"
      [attr.viewBox]="'0 0 ' + thumbWidth + ' ' + thumbHeight"
      class="shrink-0"
      aria-hidden="true">
      <path [attr.d]="thumbnailPath()" fill="none" stroke="#0f6b73" stroke-width="1.5" />
    </svg>
  }

  <div class="flex min-w-0 flex-1 flex-col gap-1">
    @if (isEmpty()) {
      <span class="text-text-secondary text-sm">
        {{ 'features.entities.geo_arc.polyline.empty' | translate }}
      </span>
    } @else {
      <span class="text-text-primary font-mono text-sm">
        {{
          'features.entities.geo_arc.polyline.summary'
            | translate: { format: format(), points: pointCount(), length: lengthKm() }
        }}
      </span>
    }

    <!--
      An unreadable or misplaced polyline is reported through the form-builder's
      field-error channel, like every other field's, so it is not repeated here. The red
      border above still marks it before the field has been touched.
    -->

    @if (!hasEndpointUids()) {
      <span class="text-text-tertiary text-xs">
        {{ 'features.entities.geo_arc.polyline.needs_endpoints' | translate }}
      </span>
    }
  </div>

  <div class="flex shrink-0 items-center gap-2">
    @if (!isEmpty()) {
      <button
        type="button"
        class="btn-cancel"
        [disabled]="isDisabled()"
        [title]="'common.clear' | translate"
        (click)="onClear()">
        <i [class]="ICONS.trash" class="mr-1"></i>
        {{ 'common.clear' | translate }}
      </button>
    }
    <button
      type="button"
      class="btn-secondary"
      [disabled]="isDisabled() || !hasEndpointUids()"
      (click)="onEditOnMap()">
      <i [class]="ICONS.path" class="mr-1"></i>
      {{ 'common.edit_on_map' | translate }}
    </button>
  </div>
</div>
